import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import PropTypes from 'prop-types';

import StrategyFreelanceContainer from '../../StrategyFreelanceContainer.jsx';
import AdminProfile from '../../Components/Profil/Admin/AdminProfile.jsx';
import UserProfile from '../../Components/Profil/User/UserProfile.jsx';
import SearchView from '../../../Search/Components/SearchView.jsx';
import Loader from '../../../../../shared/components/Loader/Loader.jsx';
import {updateResult} from '../../../Search/actions.js';

class FreelanceSearchViewContainer extends Component {
  static propTypes = {
    loading: PropTypes.bool,
  }

  static defaultProps = {
    loading: true,
  }

  onFormSuccess = (message = null) => {
    toastr.success(message ? message : 'Les modifications ont correctement été enregistrées');
  }

  refresh = (values) => {
    this.props.updateResult(this.props.match.params.offset, {...values.freelance, user: values.user});
  };

  render() {
    const {flattenSearchObject, isAdmin, loading, location, match, searchData, searchQuery, searchRouteName} = this.props;

    const offset = match?.params.offset;
    const freelance = searchData?.results[offset] ?? null;
    const user = freelance?.user ?? null;

    let children = (
      <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
        Recherche en cours...
      </Loader>
    );

    if (!loading && null !== freelance) {
      children = (
        <StrategyFreelanceContainer
          className="search-view-content page-background"
          currentUser={this.props.currentUser}
          link={{
            menu: 'search.view',
            search: flattenSearchObject(searchQuery),
            parameters: {
              offset: offset,
            }
          }}
          loading={false}
          navbar={false}
          onFormSuccess={this.onFormSuccess}
          profile={{user: user, freelance: freelance}}
          refresh={this.refresh}
          route={this.props.route}
          showSidebarMenu={!!isAdmin}
          view={isAdmin ? AdminProfile : UserProfile}
        />
      );
    }

    return (
      <SearchView
        flattenSearchObject={flattenSearchObject}
        isAdmin={isAdmin}
        location={location}
        match={match}
        searchData={searchData}
        searchQuery={searchQuery}
        searchRouteName={searchRouteName}
        title={user?.fullname ?? ''}
        viewRouteName="search.view"
      >
        {children}
      </SearchView>
    );
  }
}

export default connect(
  (state) => ({
    searchData: state.search,
  }),
  (dispatch) => ({
    updateResult: (index, value) => dispatch(updateResult(index, value)),
  })
)(FreelanceSearchViewContainer);